// extracted by mini-css-extract-plugin
export default {"profileMenu":"ProfileMenu_profileMenu__dKYwt","trigger":"ProfileMenu_trigger__SiS6Z","panel":"ProfileMenu_panel__5Rqg0","item":"ProfileMenu_item__z7gRh"};